import React from 'react';

import { PropertyWalletDetailsDTO } from '../../../services/properties';
import {
  DetailField,
  DetailFieldGrid,
  DetailFieldLabel,
  DetailFieldValue,
  DetailsSection,
  DetailsSectionTitle
} from '../styles';

type Props = {
  details: PropertyWalletDetailsDTO;
  isLoading?: boolean;
};

const display = (value?: string | number): string =>
  value == null || value === '' ? '—' : String(value);

const CondominiumDetailsSummary: React.FC<Props> = ({ details, isLoading }) => {
  const condominium = details.condominium || {};
  const syndic = details.syndic || {};

  return (
    <>
      {isLoading && (
        <p style={{ margin: '0 0 16px', color: '#6b7280' }}>Atualizando informações…</p>
      )}

      <DetailsSection>
        <DetailsSectionTitle>Endereço do imóvel</DetailsSectionTitle>
        <DetailFieldGrid $columns={4}>
          <DetailField>
            <DetailFieldLabel>Tipo do imóvel</DetailFieldLabel>
            <DetailFieldValue>
              {display(details.type?.description || details.type?.code)}
            </DetailFieldValue>
          </DetailField>
          <DetailField>
            <DetailFieldLabel>CEP</DetailFieldLabel>
            <DetailFieldValue>{display(details.address?.zipcode)}</DetailFieldValue>
          </DetailField>
          <DetailField style={{ gridColumn: 'span 2' }}>
            <DetailFieldLabel>Logradouro</DetailFieldLabel>
            <DetailFieldValue>{display(details.address?.street)}</DetailFieldValue>
          </DetailField>
          <DetailField>
            <DetailFieldLabel>Bairro</DetailFieldLabel>
            <DetailFieldValue>{display(details.address?.neighborhood)}</DetailFieldValue>
          </DetailField>
          <DetailField>
            <DetailFieldLabel>Cidade</DetailFieldLabel>
            <DetailFieldValue>{display(details.address?.city)}</DetailFieldValue>
          </DetailField>
          <DetailField>
            <DetailFieldLabel>UF</DetailFieldLabel>
            <DetailFieldValue>{display(details.address?.state)}</DetailFieldValue>
          </DetailField>
          <DetailField>
            <DetailFieldLabel>Número</DetailFieldLabel>
            <DetailFieldValue>{display(details.address?.number)}</DetailFieldValue>
          </DetailField>
          <DetailField style={{ gridColumn: '1 / -1' }}>
            <DetailFieldLabel>Complemento</DetailFieldLabel>
            <DetailFieldValue>{display(details.address?.complement)}</DetailFieldValue>
          </DetailField>
        </DetailFieldGrid>
      </DetailsSection>

      <DetailsSection>
        <DetailsSectionTitle>Informações do Condomínio</DetailsSectionTitle>
        <DetailFieldGrid $columns={3}>
          <DetailField>
            <DetailFieldLabel>CPF/CNPJ</DetailFieldLabel>
            <DetailFieldValue>{display(condominium.document)}</DetailFieldValue>
          </DetailField>
          <DetailField style={{ gridColumn: 'span 2' }}>
            <DetailFieldLabel>Razão social</DetailFieldLabel>
            <DetailFieldValue>{display(condominium.legalName)}</DetailFieldValue>
          </DetailField>
          <DetailField>
            <DetailFieldLabel>Tipo</DetailFieldLabel>
            <DetailFieldValue>{display(condominium.type)}</DetailFieldValue>
          </DetailField>
          <DetailField>
            <DetailFieldLabel>Unidades</DetailFieldLabel>
            <DetailFieldValue>{display(condominium.units)}</DetailFieldValue>
          </DetailField>
          <DetailField>
            <DetailFieldLabel>Assessor</DetailFieldLabel>
            <DetailFieldValue>{display(condominium.assessor)}</DetailFieldValue>
          </DetailField>
          <DetailField>
            <DetailFieldLabel>Telefone do condomínio</DetailFieldLabel>
            <DetailFieldValue>{display(condominium.phone)}</DetailFieldValue>
          </DetailField>
          <DetailField>
            <DetailFieldLabel>E-mail do condomínio</DetailFieldLabel>
            <DetailFieldValue>{display(condominium.email)}</DetailFieldValue>
          </DetailField>
        </DetailFieldGrid>
      </DetailsSection>

      <DetailsSection>
        <DetailsSectionTitle>Informações do Síndico</DetailsSectionTitle>
        <DetailFieldGrid $columns={3}>
          <DetailField>
            <DetailFieldLabel>Nome do Síndico</DetailFieldLabel>
            <DetailFieldValue>{display(syndic.name)}</DetailFieldValue>
          </DetailField>
          <DetailField>
            <DetailFieldLabel>CPF/CNPJ</DetailFieldLabel>
            <DetailFieldValue>{display(syndic.document)}</DetailFieldValue>
          </DetailField>
          <DetailField>
            <DetailFieldLabel>RG</DetailFieldLabel>
            <DetailFieldValue>{display(syndic.rg)}</DetailFieldValue>
          </DetailField>
          <DetailField>
            <DetailFieldLabel>Data de Nascimento</DetailFieldLabel>
            <DetailFieldValue>{display(syndic.birthDate)}</DetailFieldValue>
          </DetailField>
          <DetailField>
            <DetailFieldLabel>E-mail</DetailFieldLabel>
            <DetailFieldValue>{display(syndic.email)}</DetailFieldValue>
          </DetailField>
          <DetailField>
            <DetailFieldLabel>Telefone</DetailFieldLabel>
            <DetailFieldValue>{display(syndic.phone)}</DetailFieldValue>
          </DetailField>
        </DetailFieldGrid>
      </DetailsSection>

    </>
  );
};

export default CondominiumDetailsSummary;
